const downloadBox1 = `
    <tr>
      {greeting}     
      <tr align="center">
        <td align="center">
          <div style="border: 1px solid #107c41; border-radius: 5px; min-width: 70%; width: fit-content; margin: 0 30px">
            <div style="display: flex;text-align:center;vertical-align:middle;background:#107c41;color:white"> 
              <div style="margin: 5px auto; display: flex; align-items: center; text-align:center;vertical-align:middle">
                <p style="font-size:14px;vertical-align:middle">DOWNLOAD</p>
              </div>
            </div>
            <div style="padding: 15px 10px;">
              <p class="personalized-link">{links}</p>
            </div>
          </div>
        </td>
      </tr>
    </tr>
`

export default downloadBox1;